import React from "react";

export function MentionList({ items, command, onSelectUser, onSelectGroup }) {
  const formatUsername = (name) => {
    return name.toLowerCase().replace(/\s+/g, "");
  };

  const handleUserClick = (item) => {
    if (item.type === "user") {
      onSelectUser(item);
    } else if (item.type === "group") {
      onSelectGroup(item);
    }
    command({
      id: item.id,
      label: formatUsername(item.value),
      value: formatUsername(item.value),
    });
  };

  const groups = items.filter((item) => item.type === "group");
  const users = items.filter((item) => item.type === "user");

  return (
    <div className="mention-list">
      {groups.length > 0 && (
        <div className="p-4">
          <h3 className="text-sm font-bold text-gray-600 mb-2">Grupos</h3>
          {groups.map((item) => (
            <button
              className="flex items-center w-full gap-2 px-4 py-2 hover:bg-gray-100"
              key={item.id}
              onClick={() => handleUserClick(item)}
            >
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white overflow-hidden">
                {item.avatar_url ? (
                  <img
                    src={item.avatar_url}
                    alt={item.value}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span className="text-xl font-bold">
                    {item.value?.charAt(0).toUpperCase()}
                  </span>
                )}
              </div>
              <div className="flex flex-col items-start">
                <span className="font-semibold text-lg leading-4">
                  {item.value}
                </span>
                <span className="text-md text-gray-500">
                  #{item.value.toLowerCase().replace(/\s+/g, "")}
                </span>
              </div>
            </button>
          ))}
        </div>
      )}

      {users.length > 0 && (
        <div className="p-4">
          <h3 className="text-sm font-bold text-gray-600 mb-2">Usuarios</h3>
          {users.map((item) => (
            <button
              className="flex items-center w-full gap-2 px-4 py-2 hover:bg-gray-100"
              key={item.id}
              onClick={() => handleUserClick(item)}
            >
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white overflow-hidden">
                {item.avatar_url ? (
                  <img
                    src={item.avatar_url}
                    alt={item.value}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span className="text-xl font-bold">
                    {item.email?.charAt(0).toUpperCase()}
                  </span>
                )}
              </div>
              <div className="flex flex-col items-start">
                <span className="font-semibold text-lg leading-4">
                  {item.value}
                </span>
                <span className="text-md text-gray-500">
                  @{item.value.toLowerCase().replace(/\s+/g, "")}
                </span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
